import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { musicManager } from '../core/audio/music/musicManager'
import { MUSIC_FILES } from '../core/audio/music/musicMap'

/**
 * Binds the store's music settings to the music singleton.
 *
 * There is deliberately no unlock listener and no visibilitychange handling
 * here: Howler owns the iOS unlock, and the music must never be paused (see
 * the comment block in musicManager for the full reasoning).
 */
export const useGameMusic = () => {
  const enabled = useSelector((state) => state.ui.audio.music.enabled)
  const volume = useSelector((state) => state.ui.audio.music.volume)
  const gameCode = useSelector((state) => state.session.details.gameCode)

  // Created as soon as auth tells us which game we are — before any user
  // gesture, on purpose. Howler parks the autoplay request and flushes it on
  // the first tap, so no "tap to start" gate is needed. musicManager.init is
  // idempotent, so the null -> resolved gameCode re-run is harmless.
  useEffect(() => {
    const src = MUSIC_FILES[`${gameCode}_BG_MUSIC`] ?? null
    if (!src) return

    musicManager.init(src)
  }, [gameCode])

  useEffect(() => {
    musicManager.setEnabled(enabled)
  }, [enabled])

  useEffect(() => {
    musicManager.setVolume(volume)
  }, [volume])
}
